import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import logo from "../images/logo.png";
import { getStorage } from "../Utils/common";
import "./SimpleMobileHeader.css";

const SimpleMobileHeader = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [eligibility, setEligibility] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStorage("token");
    const eligibilityStatus = getStorage("eligibility");

    if (token) {
      setIsLoggedIn(true);
    }

    if (eligibilityStatus) {
      setEligibility(eligibilityStatus);
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleDashboardClick = () => {
    closeMenu();
    if (eligibility === 1) {
      navigate("/my-dashboard/eligibility");
    } else {
      navigate("/my-dashboard");
    }
  };

  return (
    <>
      <header className={`mobile-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="mobile-container">
          {/* Burger Menu - Left */}
          <button className="burger-btn" onClick={toggleMenu}>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </button>

          {/* Logo - Center */}
          <div className="mobile-logo">
            <Link to="/" className="mobile-logo-link" onClick={closeMenu}>
              <img src={logo} alt="Udhaar Portal Logo" className="mobile-logo-img" />
            </Link>
          </div>

          {/* Apply Now Button - Right */}
          <div className="action-button-container">
            {isLoggedIn ? (
              <button className="action-btn dashboard-action" onClick={handleDashboardClick}>
                Dashboard
              </button>
            ) : (
              <NavLink to="/apply-now" className="action-btn apply-action" onClick={closeMenu}>
                Apply Now
              </NavLink>
            )}
          </div>
        </div>
      </header>

      {/* Mobile Menu Portal */}
      {isMenuOpen && createPortal(
        <>
          <div className="menu-backdrop" onClick={closeMenu}></div>
          <div className="mobile-menu">
            <nav className="mobile-nav">
              <NavLink to="/home" className="mobile-nav-link" onClick={closeMenu}>
                Home
              </NavLink>
              <NavLink to="/about-us" className="mobile-nav-link" onClick={closeMenu}>
                About
              </NavLink>
              <NavLink to="/contact" className="mobile-nav-link" onClick={closeMenu}>
                Contact
              </NavLink>
              
              <div className="mobile-buttons">
                <NavLink to="/repayloan" className="mobile-menu-btn repay-btn" onClick={closeMenu}>
                  Repay Loan
                </NavLink>
              </div>
            </nav>
          </div>
        </>,
        document.body
      )}
    </>
  );
};

export default SimpleMobileHeader;
